import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { TabSessionStorageDispatchTypes, TabSessionStorageReAuthDispatchTypes } from "../constants/TabSessionStorage";
import { ReAuthTabData, TabData } from "../models/TabSessionStorage";
import { TabSessionDataDispatchTypes, TabSessionDataReAuthDispatchTypes } from "../models/dispatchTypes/TabSessionStorage";
import { ApplicationState } from "../redux/ApplicationState";

export const saveTabSessionStorageResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    TabSessionDataDispatchTypes
  >
> = (sessionData: TabData) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: TabSessionStorageDispatchTypes.SET_TAB_DATA_INVOKE,
    });
    const response = sessionData;
    sessionStorage.setItem("ReferralRequest", JSON.stringify(sessionData));
    dispatch({
      response: response,
      type: TabSessionStorageDispatchTypes.SET_TAB_DATA_SUCCESS,
    });
  };
};

export const saveTabSessionReAuthStorageResp: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    TabSessionDataReAuthDispatchTypes
  >
> = (sessionData: ReAuthTabData) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: TabSessionStorageReAuthDispatchTypes.SET_TAB_DATA_RE_AUTH_INVOKE,
    });
    const response = sessionData;
    sessionStorage.setItem("ReAuthRequest", JSON.stringify(sessionData));
    dispatch({
      response: response,
      type: TabSessionStorageReAuthDispatchTypes.SET_TAB_DATA_RE_AUTH_SUCCESS,
    });
  };
};
